import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Heading,
  Link,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";

import { MinusIcon } from "@chakra-ui/icons";

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_224_4910)">
      <path
        d="M12 5V19"
        stroke="#768178"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        stroke="#768178"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_224_4910">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AccordionSection = ({ title, content, buttonText, href }: any) => {
  const buttonStyle = buttonText ? {} : { display: "none" };

  // const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  // const handleAccordionToggle = () => {
  //   setIsAccordionOpen(!isAccordionOpen);
  // };

  return (
    <Accordion allowToggle width="100%" maxW="lg" bg="white">
      <AccordionItem borderTop="none">
        {({ isExpanded }) => (
          <>
            <Heading>
              <AccordionButton
                display="flex"
                fontFamily={"TradeGothic LT Bold"}
                fontWeight={"700"}
                fontSize={"3xl"}
                alignItems="center"
                justifyContent="space-between"
                py={{ base: "5", md: "5" }}
                px={{ base: "0", md: "8px" }}
                textTransform="uppercase"
                _hover={{ bg: "transparent" }}
                // onClick={handleAccordionToggle}
              >
                <Text fontSize="3xl" fontWeight="700">
                  {title}
                </Text>
                {isExpanded ? (
                  <MinusIcon w="24px" h="24px" color="#768178" />
                ) : (
                  <PlusIcon />
                )}
              </AccordionButton>
            </Heading>
            <AccordionPanel
              p={0}
              pb={6}
              display="flex"
              flexDirection="column"
              color="#768178"
              fontSize="md"
              fontFamily={"TradeGothic LT"}
              fontWeight={"400"}
            >
              {content.map(
                (paragraph: string, index: React.Key | null | undefined) => (
                  <Text key={index} pb={2}>
                    {paragraph}
                  </Text>
                )
              )}
              {/* {buttonText && (
                <Link href={href}>
                  <Button
                    bg="transparent"
                    aria-label="accordion"
                    color="#D9A542"
                    pl={0}
                    fontWeight="bold"
                    justifyContent="flex-start"
                    textTransform="uppercase"
                    _hover={{ bg: "transparent" }}
                    style={buttonStyle}
                  >
                    {buttonText}
                  </Button>
                </Link>
              )} */}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};
